import React, { useEffect } from 'react';
import { FieldPath, useWatch } from 'react-hook-form';
import { EntityPanelVehiclesForm } from '../types';
import { useIntegratedForm } from '../../../../forms/use-integrated-form';

// This is the type we want, but because our data-strucure is so large,
// the ts compiler tells us that the computation here is excessive
///**
// * Find all paths within `EventPanelFormType`
// * with a form value that extends `isOther`
// */
//type FieldPathsWithIsOtherValue<
//    Path extends FieldPath<EventPanelFormType>
//> = Path extends FieldPath<EventPanelFormType>
//    ? NonNullable<FieldPathValue<EventPanelFormType, Path>> extends { isOther?: boolean }
//        ? Path
//        : never
//    : never;

/**
 * Render `other` field when the `watchPath`
 * points to an `isOther` attribute
 */
export const OtherField = ({
    watchPath,
    children,
    otherPath,
}: React.PropsWithChildren<{
    /**
     * The path we watch that returns the option
     *
     * NOTE: This is the type we want, but because our data-strucure is so large,
     * the ts compiler tells us that the computation here is excessive
     * FieldPathsWithIsOtherValue<FieldPath<EventPanelFormType>>;
     */
    watchPath: Extract<FieldPath<EntityPanelVehiclesForm>, `${any}Option`>;
    /**
     * The path we store the additional `other` text into
     */
    otherPath: Extract<FieldPath<EntityPanelVehiclesForm>, `${any}Other`>;
}>) => {
    const { form } = useIntegratedForm<EntityPanelVehiclesForm>();
    const value = useWatch({
        control: form.control,
        name: watchPath,
    });

    const isOther =
        value && typeof value === 'object' && 'isOther' in value ? value.isOther : undefined;

    // Anytime the value of `watchPath` changes to a "non-other" value,
    // clear out the "other" value
    useEffect(() => {
        if (!isOther) {
            form.setValue(otherPath, null);
        }
    }, [isOther, otherPath, form]);

    return isOther ? <>{children}</> : null;
};
